import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6ptmxh3ye: FaireProductEntity = {
  token: "p_y6ptmxh3ye",
  type: "product",
  name: "Hot Stuff Shimmer Sheer Crew Sock - Halloween",
  brandToken: "b_2z2c37uymf",
  brandName: "Sock Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/9ade23df3b454673c13564bf00315c5418faabac75da5f284d532b7a62712431.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    "Halloween 2026 Collection - AVAILABLE FOR PRE-ORDER - SHIPS 9/18.\n\n\n\nOne Size. Recommended fit US women's shoe sizes 5.5-10\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:32.557Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
